// 阿里图片直传  需在阿里 控制台中配置跨域权限
// 阿里
import OSS from "ali-oss";
import { Message, Loading } from "element-ui";
import { compressAccurately } from "image-conversion";

let client = new OSS({
  region: "oss-cn-beijing",
  accessKeyId: "LTAI5tQd9Sdfwtsv5YA2gGX8",
  accessKeySecret: "XPN833yS05CSzHTyVLvJtAbhzfR2EO",
  bucket: "wlines", // 你要上传到那个文件夹下； 这个需要在阿里云服务器建立
  endpoint: "https://oss-cn-beijing.aliyuncs.com",
  secure: true
});

// let stylePrams = '?x-oss-process=image/resize,w_300/auto-orient,1'

// ?x-oss-process=image/resize,w_300
// export function imgScale(ImgUrl) {
//   return new Promise((resolve, reject) => {
//     try {
//       client.get('hr_syqkhb_20190307085502.jpg', './aaaaaaa123.jpg', { process: 'image/resize,m_fixed,w_100,h_100'}).then(res => {
//         resolve(res)
//       })
//     } catch (e) {
//       reject(e)
//     }
//   })
// }

export function uploadImg(file, uploadUrl) {
  var suffixArr = file.name.split(".");
  var suffix = suffixArr[suffixArr.length - 1].toLowerCase();
  // var suffix = file.name.substr(file.name.indexOf(".")); // 后缀名
  console.log(suffix);
  var obj = timestamp(); // 这里是生成文件名
  // var styleName = '?x-oss-process=style/HRImgUpload'
  if (suffix !== "jpg" && suffix !== "png" && suffix !== "jpeg") {
    Message({
      type: "warning",
      message: "只能上传jpg/jpeg/png文件"
    });
    // return new Promise((resolve, reject) => {
    //   reject();
    // }).catch(e => { });
    return false;
  }

  console.log("下边走了吗？");
  var storeAs = uploadUrl + obj + "." + suffix; // 文件路径
  console.log(storeAs);
  let loadingInstance = Loading.service({
    lock: true,
    text: "加载中",
    background: "rgba(0, 0, 0, 0.7)"
  });
  return new Promise((resolve, rejust) => {
    loadingInstance.close();
    try {
      client.put(storeAs, file).then(res => {
        // resolve(res.url + stylePrams)
        resolve(res.url);
      });
    } catch (e) {
      rejust(e);
    }
  });
  async function put() {
    try {
      let result = await client.put(storeAs, file);
      return result.url;
    } catch (e) {
      return e;
    }
  }
}
// 图片 + wav
export function uploadImg3(file, uploadUrl) {
  var suffixArr = file.name.split(".");
  var suffix = suffixArr[suffixArr.length - 1].toLowerCase();
  // var suffix = file.name.substr(file.name.indexOf(".")); // 后缀名
  console.log(suffix);
  var obj = timestamp(); // 这里是生成文件名
  // var styleName = '?x-oss-process=style/HRImgUpload'
  if (
    suffix !== "jpg" &&
    suffix !== "png" &&
    suffix !== "jpeg" &&
    suffix !== "wav"
  ) {
    Message({
      type: "warning",
      message: "只能上传jgp/jpeg/png/wav文件"
    });
    return false;
  }
  var storeAs = uploadUrl + obj + "." + suffix; // 文件路径
  console.log(storeAs);
  return new Promise((resolve, rejust) => {
    try {
      client.put(storeAs, file).then(res => {
        // resolve(res.url + stylePrams)
        resolve(res.url);
      });
    } catch (e) {
      rejust(e);
    }
  });
  async function put() {
    try {
      let result = await client.put(storeAs, file);
      return result.url;
    } catch (e) {
      return e;
    }
  }
}
// 不限制文件格式
export function uploadImg2(file, uploadUrl) {
  var suffixArr = file.name.split(".");
  var suffix = suffixArr[suffixArr.length - 1].toLowerCase();
  // var suffix = file.name.substr(file.name.indexOf(".")); // 后缀名
  console.log(suffix);
  var obj = timestamp(); // 这里是生成文件名

  if (uploadUrl[uploadUrl.length - 1] == "/") {
    var storeAs = uploadUrl + suffixArr[0] + obj + "." + suffix; // 文件路径
  } else {
    var storeAs = uploadUrl + obj + "." + suffix; // 文件路径
  }

  console.log(storeAs);
  return new Promise((resolve, rejust) => {
    try {
      client.put(storeAs, file).then(res => {
        // resolve(res.url + stylePrams)
        resolve(res.url);
      });
    } catch (e) {
      rejust(e);
    }
  });
  async function put() {
    try {
      let result = await client.put(storeAs, file);
      return result.url;
    } catch (e) {
      return e;
    }
  }
}

function timestamp() {
  var time = new Date();
  let timestr = time.getTime() + "";
  var hash = parseInt(Math.random() * 100);
  return timestr + hash;
  // var y = time.getFullYear();
  // var m = time.getMonth() + 1;
  // var d = time.getDate();
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return "" + y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s);
}
function add0(m) {
  return m < 10 ? "0" + m : m;
}

// 1 声明自己的 accessKeyId 和 accessKeySecret 这个需要到阿里云里面去设置
// var client = new OSS.Wrapper({
//   region: 'oss-cn-beijing',
//   accessKeyId: 'LTAIkVUa1mIiHkJi', // 您的key
//   accessKeySecret: 'kQefbVH2kut7NAITelvm9IYDCjp8Rb', // 您的密码
//   bucket : 'wlines'  // 你要上传到那个文件夹下； 这个需要在阿里云服务器建立
// });
// console.log(client)
// // 2 图片上传方法
// export function uploadImg(f, uploadUrl) {
//   return new Promise((resolve, reject) => {
//     console.log(f.name);
//     // var val= document.getElementById("file").value;
//     var suffix = uploadUrl.substr(uploadUrl.indexOf(".")); // 后缀名
//     var obj = timestamp(); // 这里是生成文件名
//     var storeAs = uploadUrl + obj + suffix; // 文件路径
//     console.log(' => ' + storeAs);
//     client.multipartUpload(storeAs, f).then(function (result) {
//       resolve(result.url)
//       // console.log(result); // 返回对象
//       // console.log(result.url); // 返回链接
//     }).catch(function (err) {
//       console.log(err);
//       reject(err)
//     });
//   })
//   // var f = document.getElementById("file").files[0];
//   // console.log('aaa', f)

// }
// // 其他方法
// // 生成文件名
// function timestamp() {
//   var time = new Date();
//   var y = time.getFullYear();
//   var m = time.getMonth()+1;
//   var d = time.getDate();
//   var h = time.getHours();
//   var mm = time.getMinutes();
//   var s = time.getSeconds();
//   console.log(y);
//   return ""+y+add0(m)+add0(d)+add0(h)+add0(mm)+add0(s);
// }
// function add0(m) {
//   return m<10?'0'+m : m;
// }

export function base64ToFile(base64Str) {
  let dateObj = new Date();
  let time = dateObj.getTime() + "";
  let str = time.slice(-5);
  let fileName = "file_" + str + ".png";

  var arr = base64Str.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let nBlob = new Blob([u8arr], { type: mime });

  console.log("===nBlob", nBlob);

  nBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
  nBlob.name = fileName; // 文件名
  return new File([nBlob], fileName, {
    type: nBlob.type,
    lastModified: Date.now()
  });
}

export async function uploadImgNew(file0, uploadPath0) {
  return new Promise(async (resolve, reject) => {
    var suffixArr = file0.name.split(".");
    var suffix = suffixArr[suffixArr.length - 1].toLowerCase();
    if (!(suffix == "jpg" || suffix == "png" || suffix == "jpeg")) {
      reject();
      return false;
    }
    let fileStr = buildDir() + getFileExt(file0);
    let uploadPath = "ERP_web" + uploadPath0 + fileStr;
    try {
      var file = await compressImage(file0);
      client.put(uploadPath, file).then(res => {
        resolve(res.url);
      });
    } catch (e) {
      reject(e);
    }
  });
}
function compressImage(file, compress = 500) {
  return new Promise((resolve, reject) => {
    const kb = file.size / 1024;
    if (!compress || compress >= kb) {
      resolve(file);
      return;
    }
    const config = {
      size: 500,
      width: 800,
      type: file.type
    };
    compressAccurately(file, config).then(async res => {
      res.uid = file.uid;
      resolve(res);
    });
  });
}

const buildDir = () => {
  const date = new Date();
  const dir =
    "/" +
    date.getFullYear() +
    "/" +
    (date.getMonth() + 1) +
    "/" +
    date.getDate();

  function rx() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return `${dir}/${date.getTime()}-${rx()}${rx()}`;
};

function getFileExt(file) {
  if (file.type === "image/png") {
    return ".png";
  }
  if (file.type === "image/jpeg") {
    return ".jpg";
  }
  const name = file.name;
  const ext = name.split(".").pop();
  if (ext != null && ext !== "") {
    return "." + ext.toLowerCase();
  }
  return "";
}
